<template>
  <div class="timeline-item">
    <span class="timeline-item__date" >{{ date }}</span>
    <h3 class="timeline-item__title">{{ title }}</h3>
    <p class="timeline-item__message" v-html="message"></p>
  </div>
</template>

<script>
  export default {
    name: 'UpdatesTimeline-item',

    props: ['title', 'message', 'date']
  }
</script>

<style lang="scss" scoped>
  @import "~scss/variables";

  .timeline-item__date {
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    line-height: 120%;
    color: rgba(0, 0, 0, 0.4);
  }

  .timeline-item__title {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 29px;
    color: #000000;
  }

  .timeline-item {
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    line-height: 24px;
    color: #000000;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.Item.vue